<template>
  <div v-if="appointment">
    <v-divider v-if="!dense" class="my-8" />

    <v-row>
      <v-col>
        <h3 v-if="dense" class="grey--text text--darken-1 mb-2">
          {{ $t('appointment.label.realties') }}
        </h3>
        <h2 v-else>
          {{ $t('appointment.label.realties') }}
        </h2>
      </v-col>
    </v-row>

    <v-data-table
      :items="mergedRealtiesWithStatus"
      :headers="headers"
      :dense="dense"
      mobile-breakpoint="20"
      hide-default-footer
      single-expand
      disable-sort
      show-expand
    >
      <template v-slot:[`item.code`]="{ item }">
        <v-chip small>
          <small v-if="dense" class="d-block mw-50 text-truncate" v-html="item.code" />
          <span v-else class="d-block" v-html="item.code" />
        </v-chip>
      </template>
      <template v-slot:[`item.address`]="{ item }">
        <small v-if="dense" class="d-block mw-100 text-truncate" v-html="item.address" />
        <span v-else class="d-block" v-html="item.address" />
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="hasItemStatus">
          <small v-if="dense" class="d-block mw-100 text-truncate" v-html="$t(`appointment.statusTable.realized.${item.done}`)" />
          <span v-else class="d-block" v-html="$t(`appointment.statusTable.realized.${item.done}`)" />
        </div>
        <span v-else class="caption">---</span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="ma-0 pa-0">
          <v-card class="pa-5 grey lighten-4" elevation="0" tile flat>
            <AppointmentRealtyDetails :item="item" :dense="dense" />
            <AppointmentRealtyStatus v-if="hasItemStatus" :item="item" :dense="dense" />
          </v-card>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AppointmentRealtyDetails from './realtiesTableComponents/AppointmentRealtyDetails'
import AppointmentRealtyStatus from './realtiesTableComponents/AppointmentRealtyStatus'

export default {
  name: 'AppointmentRealties',

  components: {
    AppointmentRealtyDetails,
    AppointmentRealtyStatus,
  },

  props: {
    appointment: {
      type: Object,
      required: true,
    },

    dense: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    status() {
      return this.appointment?.item_status
    },

    realties() {
      return this.appointment?.realties
    },

    hasItemStatus() {
      return this.status?.length >= 1
    },

    mergedRealtiesWithStatus() {
      if (!this.realties && !this.status) return
      return this.realties.map((realty) => ({ ...realty, ...this.status.find((status) => status.realty_id === realty.id) }))
    }
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('appointment.label.code'),
          value: 'code',
          align: 'start',
          width: this.dense ? 50 : 200,
        },
        {
          text: this.$t('appointment.label.realtyAddress'),
          value: 'address',
          align: 'start',
        },
        {
          text: this.$t('appointment.label.status'),
          value: 'status',
          align: 'start',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  }
}
</script>
